import React from 'react'

import { InterSvgIcon } from 'components'

import { TIntensity, TSignalFeedback } from '../types/SignalFeedback.types'

export function useSignalFeedback({ icon, type }: TSignalFeedback) {
  const color = type === 'gray' ? 'black' : 'white'

  const InterIcon = () => <InterSvgIcon color={color} iconRef={icon} height={32} width={32} />

  const intensity: TIntensity = type === 'gray' ? 'subtle' : 'bold'

  return { InterIcon, intensity, color }
}
